import request from "../common/request";
import store from "@/store";
import {
  IScoreboardResponse,
  IScoreboard,
  IScoreboardParams,
  IWenzhengScoreResponse,
  IWenzhengScore,
  IResponse,
  HotlineRes,
  HotlineRes_new,
  IJyhScoreboard,
  IDateList,
  ICircleScoreboard,
  dragVerifyGetCodeRes,
  dragVerifyCheckCodeData,
  dragVerifyCheckCodeRes
  // HotlineNodes
} from "./types";
/**
 * 网络请求类 接口调用
 */
class RequestIndex {
  get token() {
    return store.state.token;
  }
  get appId() {
    return store.state.appId;
  }

  /**
   * 平湖号积分榜
   * @param infoClassifyId 专题id
   */
  scoreboard(
    params: IScoreboardParams
  ): Promise<IScoreboardResponse<IScoreboard>> {
    return request.post("/wan/scoreboard.html", params);
  }

  /**
   * 教育号
   * @param infoClassifyId 专题id
   */
  jyhScoreboard(
    params: IScoreboardParams
  ): Promise<IScoreboardResponse<IJyhScoreboard>> {
    return request.post("/wan/jyh/scoreboard.html", params);
  }

  /**
   * 平湖号积分榜
   * @param infoClassifyId 专题id
   */
  wenzhangRanking(params: {
    appId: string;
    endTime: string;
    sortColumn: string;
    startTime: string;
  }): Promise<IWenzhengScoreResponse> {
    return request.post("/wz/analysis/complete.html", params);
  }
  /**
   * 圈子榜单
   * @param params
   * @returns
   */
  circleScoreboard(params: {
    appId: string;
    beginTime: string;
    circleTypeId: string;
    endTime: string;
  }): Promise<IScoreboardResponse<ICircleScoreboard>> {
    return request.post("/wan/circle/scoreboard.html", params);
  }

  /**
   * 圈子榜单日期接口
   * @param params
   * @returns
   */
  getScoreboardDateList(params: {
    type: string;
  }): Promise<IScoreboardResponse<IDateList>> {
    return request.post("/wan/circle/getScoreboardDateList.html", params);
  }
  /**
   * 圈子详情
   * @param params
   * @returns
   */
  quanziDetail(params: {
    appId: string;
    circleTypeId: string;
  }): Promise<IScoreboardResponse<IDateList>> {
    return request.post("/wan/circle/type/detail.html", params);
  }

  /** ⬇️梁平热线h5⬇️ */
  getHotlineList(params: {
    appId: string;
    sessionId?: string;
    token?: string;
    hotlineTypeId?: number;
    sourceType: number;
  }): Promise<IResponse<HotlineRes_new>> {
    // "/hotlineV2.html" 原热线接口
    return request.post("/configCommonTypeTree/list.html", params);
  }
  /** ⬆️梁平热线h5⬆️ */

  /** ⬇️其他区县热线h5⬇️ */
  getHotlineList_other(params: {
    appId: string;
    sessionId?: string;
    token?: string;
    hotlineTypeId?: number;
  }): Promise<IResponse<HotlineRes>> {
    return request.post("/hotlineV2.html", params);
  }

  /**南岸疫情专题 */
  getColumns(appId: string, parentCode: string): Promise<IResponse<any>> {
    return request.post("/getColumns.html", {
      appId: appId,
      parentCode: parentCode
    });
  }

  getNewsList(
    appId: string,
    columnId: string,
    lastId?: string | number,
    lastSortNo?: string | number,
    lastOnlineTime?: string
  ): Promise<IResponse<any>> {
    return request.post("/info/news.html", {
      appId: appId,
      columnId: columnId,
      isCarousel: false,
      lastId: lastId,
      lastSortNo: lastSortNo,
      lastOnlineTime: lastOnlineTime
    });
  }
  // 潼南积分支付
  paymentIntegral(params: {
    appId: number;
    goods_id: string;
    goods_name: string;
    machine_id: string;
    nonce_str: string;
    pay_price: number;
    shelf_id: string;
    sign: string;
    sign_type: string;
    token: string;
    trade_no: string;
    version: string;
  }): Promise<IResponse<any>> {
    return request.post(
      process.env.VUE_APP_BASE_API_TN + "/api/third/paymentIntegral",
      { ...params }
    );
  }
  // 潼南获取积分比例
  integralProportion(appId: string): Promise<IResponse<any>> {
    return request.post(
      process.env.VUE_APP_BASE_API_TN + "/api/third/integralProportion",
      {
        appId
      }
    );
  }
  /** 获取分享信息 */
  getShareInfoMethod(appId: string): Promise<any> {
    return request.post("/getShareInfo.html", {
      appId
    });
  }

  // 人机校验获取验证码
  dragVerifyGetCode(params: {
    captchaType: string;
    ts: number;
    appId: number;
  }): Promise<dragVerifyGetCodeRes> {
    return request.post(
      process.env.VUE_APP_CAPTCHA_API + "/captcha/get",
      params
    );
  }
  // 人机校验验证验证码正确性
  dragVerifyCheckCode(params: {
    captchaType: string;
    pointJson: string;
    token: string;
    ts: number;
    appId: number;
  }): Promise<dragVerifyCheckCodeRes> {
    return request.post(
      process.env.VUE_APP_CAPTCHA_API + "/captcha/check",
      params
    );
  }

  // 获取移动端集成页icon、name、link
  getMobileIntegrationData() {
    return request.get(
      "https://h5cloud.cqliving.com/statics/data/0other/wangxuan/data.json"
    );
  }

  // 万州改版 办结率排行榜
  rateRanking(params: {
    appId: string | number;
    sortType: string | number; //排序类型{1:正序;0:倒序}
  }): Promise<IWenzhengScoreResponse> {
    return request.get(
      `/wz/completion/rate/rank.html?appId=${params.appId}&sortType=${params.sortType}`
    );
  }

  // 万州改版 个人号发稿
  postRelease(obj: object): Promise<IResponse> {
    return request.post("/wan/saveInfo.html", obj);
  }

  /********** lpwp  梁平网盘********************** */
  /**
   * 获取阿里云配置
   * @param suffix 文件后缀
   */
  getAliOssConfig = (suffix: string) => {
    // let url = process.env.VITE_BASE_URL_API;
    return request.post(
      // `${url}/common/alioss/getConfig.html`,
      "https://exapi.cqliving.com/common/alioss/getConfig.html",
      {
        appId: 501,
        suffix,
        withoutToken: true
      }
    );
  };

  wangpanjson(): Promise<any> {
    return request.get(
      `http://h5cloud.cqliving.com/statics/data/0other/wangpan/wpConfig.json`
    );
  }

  // 获取图片列表
  getPicList(params: {
    u: string | number;
    informationId: string | number;
  }): Promise<IWenzhengScoreResponse> {
    return request.post(
      `${process.env.VUE_APP_LPWP_API}/zb_tmp/live_resources.html`,
      {
        u: params.u,
        informationId: params.informationId
      }
    );
  }

  // 发布图片
  upPic(params: {
    u: string | number;
    imgs: string | number;
    infoClassifyId: string | number;
    informationId: string | number;
    compereId: string | number;
  }): Promise<IWenzhengScoreResponse> {
    return request.post(
      `${process.env.VUE_APP_LPWP_API}/zb_tmp/live_info_detail_add.html`,
      {
        u: params.u,
        imgs: params.imgs,
        appId: 1,
        infoClassifyId: params.infoClassifyId,
        informationId: params.informationId,
        compereId: params.compereId
      }
    );
  }

  // 下线
  onlinePic(params: {
    u: string | number;
    id: string | number;
  }): Promise<IWenzhengScoreResponse> {
    return request.post(
      `${process.env.VUE_APP_LPWP_API}/zb_tmp/live_info_detail_online.html`,
      {
        u: params.u,
        id: params.id
      }
    );
  }

  // 聚合新闻列表
  listNews(columnsId: string | number, lastId?: string): Promise<any> {
    return request.post(`${process.env.VUE_APP_KZ_API}/hlx/list/news.html`, {
      appId: 22,
      columnsId,
      lastId
    });
  }

  // 占位新闻列表
  seatNews(ids: string): Promise<any> {
    return request.post(`${process.env.VUE_APP_KZ_API}/hlx/list/seat.html`, {
      ids
    });
  }

  // 占位新闻列表
  shortVideo(lastId?: string): Promise<any> {
    return request.post(
      `${process.env.VUE_APP_KZ_API}/video/getVideoInfoList.html`,
      {
        lastId,
        appId: 22,
        type: 1
      }
    );
  }

  //三级治理中心token换用户信息
  fetchUserInfoBySjzl(params: {
    sjzlToken: string;
    pjCode: string;
    appId: string;
  }) {
    return request.get<any>(
      `${process.env.VUE_APP_SJZL_BASE_API}/common/sjzl/zwyUrl.html`,
      {
        params
      }
    );
  }

  // 云阳-理论宣讲应用平台
  getLlxjptJson() {
    return request.get(
      `https://imagecdn.cqliving.com/images2/40/img/lyyy.json?t=${new Date().getTime()}`
    );
  }
}
export default new RequestIndex();
